"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRealUserMonitoring = void 0;

var _reactUse = require("react-use");

var _utils = require("../utils");

/**
 * Upon mount, will initialize the RealUserMonitoring
 * tracking leveraging the passed in options.
 *
 * @param options RUMOptions
 */
var useRealUserMonitoring = function useRealUserMonitoring(options) {
  (0, _reactUse.useMount)(function () {
    (0, _utils.initializeRealUserMonitoring)(options);
  });
};

exports.useRealUserMonitoring = useRealUserMonitoring;
//# sourceMappingURL=index.js.map